import { put, takeEvery } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { updateEnrollment, enrollUser, unenrollUser } from '../../utils/common-functions';

function* updateOneEnrollment({ payload }) {
    try {
        yield updateEnrollment(payload.classId, payload.userId, payload.data);
        yield put({ type: actions.ENROLLMENT_UPDATED, payload });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { message: 'A matrícula não pôde ser atualizada' },
        });
    }
}

function* enrollUsers({ payload }) {
    try {
        yield enrollUser(stringData(payload));
        yield put({ type: actions.USER_ENROLLED, payload: payload });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { message: 'A matrícula não pôde ser realizada. Tente recarregar a página' },
        });
    }
}

function* enrollUsersFromResgisterNewUser({ payload }) {
    try {
        yield enrollUser(stringData(payload));
        yield put({ type: actions.USER_ENROLLED, payload: payload });
        yield put({ type: actions.CLEAR_NEW_USER });
        yield put({ type: actions.TOGGLE_SHOW_FORM_SEARCH_REALMS, payload: true });
        yield put({ type: actions.TOGGLE_SHOW_FORM, payload: false });
        yield put({
            type: actions.CHANGE_REDIRECT_TO_TABLE_USERS,
            payload: true,
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { message: 'A matrícula não pôde ser realizada. Tente recarregar a página' },
        });
    }
}

function* unenrollUsers({ payload }) {

    try {
        yield unenrollUser(stringData(payload));
        yield put({ type: actions.USER_UNENROLLED, payload: payload });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { message: 'A operação não pôde ser realizada. Tente recarregar a página' },
        });
    }
}

const stringData = (data) => ({
    userId: Array.isArray(data.userId) ? data.userId.toString() : data.userId,
    classId: Array.isArray(data.classId) ? data.classId.toString() : data.classId,
});

export default function* users() {
    yield takeEvery(actions.ASYNC_UPDATE_ENROLLMENT, updateOneEnrollment);
    yield takeEvery(actions.ASYNC_ENROLL_USER, enrollUsers);
    yield takeEvery(actions.ASYNC_UNENROLL_USER, unenrollUsers);
    yield takeEvery(actions.ASYNC_ENROLL_USER_FROM_REGISTER_NEW_USER, enrollUsersFromResgisterNewUser);
}



// WEBPACK FOOTER //
// ./src/components/admin/admin.saga.js